// Run-time checking of preconditions.

'use strict';

// Precondition function that checks if the given predicate is true.
// If not, it will throw an error.
exports.argument = function(predicate, message) {
    if (!predicate) {
        throw new Error(message);
    }
};

// Precondition function that checks if the given assertion is true.
// If not, it will throw an error.
exports.assert = exports.argument;



/*****************
 ** WEBPACK FOOTER
 ** ./~/opentype.js/src/check.js
 ** module id = 81
 ** module chunks = 0
 **/